<script>
export default {
  props: {
    type: {
      default: undefined,
      type: String,
    },
  },
}
</script>

<template>
  <div>
    <b-row
      v-if="
        type === 'default' ||
          type === 'homepage' ||
          type === 'data-center' ||
          type === 'news' ||
          type === 'academic-journal' ||
          type === 'infographic' ||
          type === 'directory' ||
          type === 'legal-analysis'
      "
      class="w-100 mx-0"
    >
      <b-col cols="12" class="px-0">
        <b-skeleton-img
          animation="wave"
          no-aspect
          :height="type === 'homepage' ? '35rem' : '25rem'"
        >
        </b-skeleton-img>
      </b-col>
      <b-container class="my-5">
        <b-row>
          <b-col
            v-for="(skeleton, index) in 6"
            :key="index"
            cols="lg-4"
            class="mb-4"
          >
            <b-card no-body img-top>
              <b-skeleton-img card-img="top" aspect="3:1"></b-skeleton-img>
              <b-card-body>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="75%"></b-skeleton>
                <b-skeleton></b-skeleton>
                <b-skeleton width="65%"></b-skeleton>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-row>

    <b-row v-if="type === 'about'" class="w-100 mx-0">
      <b-col cols="12" class="px-0">
        <b-skeleton-img animation="wave" no-aspect height="25rem">
        </b-skeleton-img>
      </b-col>
      <b-container class="my-5">
        <b-row>
          <b-col cols="lg-8" class="mt-5">
            <b-skeleton height="500px"></b-skeleton>
          </b-col>
          <b-col cols="lg-4">
            <b-card no-body img-top>
              <b-skeleton-img card-img="top" aspect="3:1"></b-skeleton-img>
              <b-card-body>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="75%"></b-skeleton>
                <b-skeleton></b-skeleton>
                <b-skeleton width="65%"></b-skeleton>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </b-row>

    <b-row v-if="type === 'glossary'" class="w-100 mx-0">
      <b-col cols="12" class="px-0">
        <b-skeleton-img animation="wave" no-aspect height="23rem">
        </b-skeleton-img>
      </b-col>
      <b-container class="my-5">
        <b-row>
          <b-col cols="12">
            <b-skeleton
              width="100%"
              height="4rem"
              style="border-radius: 10px"
            ></b-skeleton>
          </b-col>
          <b-col cols="12" class="mt-5">
            <b-skeleton
              width="100%"
              height="5rem"
              style="border-radius: 10px"
            ></b-skeleton>
          </b-col>
        </b-row>
      </b-container>
    </b-row>

    <b-container v-if="type === 'faq'" class="w-100">
      <b-row class="w-100 my-5">
        <b-col cols="12" class="mt-5">
          <b-skeleton width="15%" height="3rem" class="mx-auto"></b-skeleton>
        </b-col>
        <b-col cols="12" class="mt-5">
          <b-skeleton
            width="100%"
            height="4rem"
            style="border-radius: 10px"
          ></b-skeleton>
        </b-col>
        <b-col cols="12" class="mt-5"></b-col>
        <b-col v-for="index in 5" :key="index" cols="12" class="mt-3">
          <b-skeleton width="100%" height="7.5rem"></b-skeleton>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-if="type === 'contact'" class="w-100">
      <b-row class="w-100 my-5">
        <b-col cols="12" class="my-4">
          <b-skeleton-img
            animation="wave"
            no-aspect
            height="2.5rem"
            width="25%"
          >
          </b-skeleton-img>
        </b-col>
        <b-container class="my-4">
          <b-row>
            <b-col cols="lg-6" class="my-3">
              <b-skeleton type="input"></b-skeleton>
            </b-col>
            <b-col cols="lg-6" class="my-3">
              <b-skeleton type="input"></b-skeleton>
            </b-col>
            <b-col cols="lg-12" class="my-3">
              <b-skeleton type="input"></b-skeleton>
            </b-col>
            <b-col cols="lg-12" class="my-3">
              <b-skeleton type="input" height="5rem"></b-skeleton>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
    </b-container>

    <b-container v-if="type === 'data-center-single'" class="w-100 my-5">
      <b-row>
        <b-col cols="lg-8">
          <b-skeleton height="2.5rem" width="80%"></b-skeleton>
          <b-skeleton height="2.5rem" width="65%" class="mb-3"></b-skeleton>
          <b-skeleton height="2rem"></b-skeleton>
          <b-skeleton height="2rem"></b-skeleton>
          <b-skeleton height="2rem"></b-skeleton>
          <b-skeleton height="1000px" class="mt-3"></b-skeleton>
        </b-col>
        <b-col cols="lg-4">
          <b-card
            :style="{ border: '2px solid rgba(0,0,0,.25)', borderRadius: '0' }"
          >
            <b-skeleton height="2rem"></b-skeleton>
            <b-skeleton height="1rem" class="mt-4"></b-skeleton>
            <b-skeleton height="1rem"></b-skeleton>
            <b-skeleton height="1rem" width="45%"></b-skeleton>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-if="type === 'academic-journal-single'" class="w-100 my-5">
      <b-row>
        <b-col cols="lg-4">
          <b-card
            :style="{ border: '2px solid rgba(0,0,0,.25)', borderRadius: '0' }"
          >
            <b-skeleton height="2rem"></b-skeleton>
            <b-skeleton height="1rem" class="mt-4"></b-skeleton>
            <b-skeleton height="1rem"></b-skeleton>
            <b-skeleton height="1rem" width="45%"></b-skeleton>
          </b-card>
        </b-col>
        <b-col cols="lg-8">
          <b-skeleton height="2.5rem" width="80%"></b-skeleton>
          <b-skeleton height="2.5rem" width="65%" class="mb-3"></b-skeleton>
          <b-skeleton height="2rem"></b-skeleton>
          <b-skeleton height="2rem"></b-skeleton>
          <b-skeleton height="2rem"></b-skeleton>
          <b-skeleton height="1000px" class="mt-3"></b-skeleton>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-if="type === 'news-single'" class="w-100 my-5">
      <b-row>
        <b-col cols="lg-12">
          <b-skeleton height="2rem" width="50%" class="mb-4"></b-skeleton>
          <b-skeleton height="2.5rem"></b-skeleton>
          <b-skeleton height="2.5rem" width="50%"></b-skeleton>
          <b-skeleton height="1.5rem" width="30%" class="my-3"></b-skeleton>
          <b-skeleton height="7.5rem"></b-skeleton>
          <b-skeleton height="5rem"></b-skeleton>
          <b-skeleton height="10rem"></b-skeleton>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-if="type === 'legal-analysis-single'" class="w-100 my-5">
      <b-row>
        <b-col>
          <b-skeleton height="2rem" width="50%" class="mb-5"></b-skeleton>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="lg-8">
          <b-skeleton height="2.5rem" class="mb-2"></b-skeleton>
          <b-skeleton height="2.5rem" width="50%"></b-skeleton>
          <b-skeleton
            height="1.5rem"
            width="30%"
            class="mt-3 mb-4"
          ></b-skeleton>
          <b-skeleton height="7.5rem" class="mb-3"></b-skeleton>
          <b-skeleton height="10rem" class="mb-3"></b-skeleton>
          <b-skeleton height="5rem"></b-skeleton>
        </b-col>
        <b-col cols="lg-4" class="pl-3 pl-lg-5">
          <b-card
            class="mb-5"
            :style="{ border: '2px solid rgba(0,0,0,.25)', borderRadius: '0' }"
          >
            <b-skeleton height="2rem"></b-skeleton>
            <b-skeleton height="1rem" class="mt-4"></b-skeleton>
            <b-skeleton height="1rem"></b-skeleton>
            <b-skeleton height="1rem" width="45%"></b-skeleton>
          </b-card>

          <b-skeleton
            height="2rem"
            class="mb-3 w-50"
            style="margin-top: 5rem"
          ></b-skeleton>
          <b-card
            :style="{ border: '2px solid rgba(0,0,0,.25)', borderRadius: '0' }"
          >
            <b-skeleton height="1rem" width="55%" class="mb-3"></b-skeleton>
            <b-skeleton height="1rem" width="85%" class="mb-3"></b-skeleton>
            <b-skeleton height="1rem" width="65%" class="mb-3"></b-skeleton>
            <b-skeleton height="1rem" width="75%" class="mb-3"></b-skeleton>
            <b-skeleton height="1rem" width="85%" class="mb-3"></b-skeleton>
            <b-skeleton height="1rem" width="55%" class="mb-3"></b-skeleton>
            <b-skeleton height="1rem" width="95%" class="mb-3"></b-skeleton>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-container
      v-if="type === 'search'"
      class="w-100"
      style="margin: 2.5rem auto"
    >
      <b-row>
        <b-col cols="12">
          <b-skeleton height="2.5rem" class="mb-5 w-50"></b-skeleton>
        </b-col>
        <b-col cols="lg-3">
          <div
            class="card"
            :style="{ border: '2px solid rgba(0,0,0,.25)', borderRadius: '0' }"
          >
            <div
              class="card-header"
              style="border-bottom: 2px solid rgba(0,0,0,.25)"
            >
              <b-skeleton height="2rem"></b-skeleton>
            </div>
            <div class="card-body">
              <b-skeleton height="1.25rem" class="mt-4 mb-2"></b-skeleton>
              <b-skeleton height="1.25rem" class="mb-2"></b-skeleton>
              <b-skeleton height="1.25rem" class="mb-2"></b-skeleton>
              <b-skeleton height="1.25rem" class="mb-2"></b-skeleton>
              <b-skeleton height="1.25rem" class="mb-2"></b-skeleton>
              <b-skeleton height="1.25rem" class="mb-2"></b-skeleton>
              <b-skeleton height="1.25rem" class="mb-2"></b-skeleton>
              <b-skeleton height="1.25rem" class="mb-4"></b-skeleton>
            </div>
          </div>
        </b-col>
        <b-col cols="9">
          <b-skeleton height="4rem" class="mb-3"></b-skeleton>
          <div
            v-for="index in 2"
            :key="index"
            class="card p-4 mb-3"
            :style="{
              border: '2px solid rgba(0,0,0,.25)',
              borderRadius: '10px',
            }"
          >
            <b-skeleton height="1.5rem" class="mb-3 w-25"></b-skeleton>
            <b-skeleton height="2rem" class="mb-3 w-75"></b-skeleton>
            <b-skeleton height="5rem"></b-skeleton>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-if="type === 'tou'" style="min-height: 65vh">
      <img src="@assets/icons/loading.gif" alt="loading" class="loadingIcon" />
    </b-container>
  </div>
</template>
